import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import PlusIcon from '../../../../../shared/library/icons/plus-icon.svg';
import {MobileContext} from '../../../../../shared/enhancers/mobile-enhancer';

const SmallPlusIcon = glamorous(PlusIcon)({height: 13, width: 13});
const LargePlusIcon = glamorous(PlusIcon)({height: 29, width: 29});

import FloatingActionButton, {
  SMALL,
  LARGE,
  ROW,
  COLUMN
} from '../../../../../shared/library/buttons/floating-action';

const AddToolButton = ({adjective = '', onClick, minimal = false}) => {
  const isMobile = useContext(MobileContext);
  const description = `Add ${adjective} tool`;
  return (
    <FloatingActionButton
      dataTestId="addTool"
      size={isMobile || minimal ? SMALL : LARGE}
      orientation={isMobile || minimal ? ROW : COLUMN}
      icon={isMobile || minimal ? <SmallPlusIcon /> : <LargePlusIcon />}
      description={description}
      onClick={onClick}
    />
  );
};

AddToolButton.propTypes = {
  adjective: PropTypes.string,
  onClick: PropTypes.func,
  minimal: PropTypes.bool
};

export default AddToolButton;
